import { IonAvatar, IonCard, IonIcon, IonImg, useIonModal } from "@ionic/react";
import { medal } from "ionicons/icons";
import UserName from "./UserName";
import { ReactComponent as TradesIcon } from "../assets/graphics/mode_heat.svg";
import { ReactComponent as StreaksIcon } from "../assets/graphics/mode_streaks.svg";
import ProfitIndicator from "./ProfitIndicator";
import EarningsIndicator from "./EarningsIndicator";
import { useEffect, useState } from "react";
import { subscribeToBot, useBotsStore } from "../stores/bots.store";
import ConfigSummary from "./ConfigSummary";

interface Props {
  lobby: any;
  instanceId?: number;
}

const LobbyPlacings: React.FC<Props> = ({ lobby, instanceId }) => {
  const [selectedBot, setSelectedBot] = useState("");
  const bot = useBotsStore(state => state.bots.find(b => b.id === selectedBot));

  useEffect(() => {
    let unsubscribe: any;
    if (selectedBot) {
      unsubscribe = subscribeToBot(selectedBot);
    }
    return () => unsubscribe && unsubscribe();
  }, [selectedBot]);

  const [presentConfig, dismissConfig] = useIonModal(ConfigSummary, {
    bot,
    onDismiss: () => dismissConfig()
  });

  const showConfigCard = (botId: string) => {
    setSelectedBot(botId);
    presentConfig();
  };

  return (
    <IonCard className="bg-primary-80">
      <div className="flex flex-col grow rounded-t-lg bg-primary-70">
        <div className="flex items-center m-2">
          <div className="bg-primary-80 text-primary-50 p-1 h-6 w-6 rounded-md">
            <IonIcon icon={medal} />
          </div>
          <div className="text-lg ml-2 font-semibold text-white">Placings</div>
        </div>
        <div className="bg-primary-80 p-2">
          <div className="flex ml-auto mr-0 w-min gap-x-4">
            {["Trades", "Streak", "Profit", "Earnings"].map(key => (
              <div key={key} className="text-[10px] text-primary-40 uppercase">
                {key}
              </div>
            ))}
          </div>
        </div>
        {lobby?.standings?.slice(0, 5).map((s: any, i: number) => (
          <div
            onClick={() => showConfigCard(s.botId)}
            className="flex bg-primary-90 p-2 border-b border-primary-80
              hover:bg-primary-80 rounded cursor-pointer
            "
            key={`standings-${instanceId || 1}-${s.botId}`}
          >
            <IonAvatar className="h-12 w-12">
              <IonImg src={s?.img} />
              <span className="absolute -mt-4 px-1 rounded-full bg-primary-90 text-yellow-400 text-sm">
                {i + 1}
              </span>
            </IonAvatar>
            <div className="flex flex-col justify-center px-1 text-sm">
              {s.name}
              <UserName small userId={s.user} />
            </div>
            <div className="flex items-center ml-auto mr-0 w-min gap-x-3">
              <div className="flex text-xs text-white">
                <div className="bg-[#ff7f0a] opacity-70 p-[2px] rounded h-4 mr-1">
                  <TradesIcon />
                </div>
                {s?.tradeCount}
              </div>
              <div className="text-xs text-white flex">
                <StreaksIcon /> {s?.profitStreak}/{s?.maxProfitStreak}
              </div>
              <ProfitIndicator profit={s?.profit} />
              <EarningsIndicator earnings={s?.earnings} />
            </div>
          </div>
        ))}
      </div>
    </IonCard>
  );
};

export default LobbyPlacings;
